/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiHttpBody } from '../../models/api-http-body';

export interface AchievementServiceGenerateAchievementImage$Params {
  label: string;
  message: string;
  color: string;
}

export function achievementServiceGenerateAchievementImage(http: HttpClient, rootUrl: string, params: AchievementServiceGenerateAchievementImage$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiHttpBody>> {
  const rb = new RequestBuilder(rootUrl, achievementServiceGenerateAchievementImage.PATH, 'get');
  if (params) {
    rb.query('label', params.label, {});
    rb.query('message', params.message, {});
    rb.query('color', params.color, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiHttpBody>;
    })
  );
}

achievementServiceGenerateAchievementImage.PATH = '/api/v3/gateway/imagegen/achievement';
